import * as types from './types';
import { loading, handleErrorException, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const getApplicationsAndStudents = confidenceLevel => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_APPLICATIONS, true));
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_STUDENTS, true));
      const response = await MPWWebApi.getGeneric(
        `Application/GetApplicationsAndStudentsForFamilyMatch/${confidenceLevel}`
      );
      dispatch(
        success(
          types.FAMILY_MATCH_GET_APPLICATIONS_AND_STUDENTS,
          response.data.Data
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching data. Please try again',
      };
      dispatch(
        handleErrorException(err, types.FAMILY_MATCH_SET_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_APPLICATIONS, false));
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_STUDENTS, false));
    }
  };
};

export const writeApplicationWithStudentMatch = systemIdAndStudentIdSeed => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_APPLICATIONS, true));
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_STUDENTS, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Application/WriteApplicationWithStudentMatch`,
        systemIdAndStudentIdSeed
      );
      dispatch(
        success(
          types.FAMILY_MATCH_WRITE_APPLICATION_WITH_MATCHED_STUDENT,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while addding the student to the application. Please try again',
      };
      dispatch(
        handleErrorException(err, types.FAMILY_MATCH_SET_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_APPLICATIONS, false));
      dispatch(loading(types.FAMILY_MATCH_SET_FETCHING_STUDENTS, false));
    }
  };
};

export const setSelectedIds = objIds => {
  return {
    type: types.FAMILY_MATCH_SET_SYSTEMID_AND_HHID,
    payload: objIds,
  };
};

export const addSelectedStudentIdSeed = studentIdSeed => {
  return {
    type: types.FAMILY_MATCH_ADD_STUDENT_ID_SEED,
    payload: studentIdSeed,
  };
};

export const removeSelectedStudentIdSeed = studentIdSeed => {
  return {
    type: types.FAMILY_MATCH_REMOVE_STUDENT_ID_SEED,
    payload: studentIdSeed,
  };
};

export const setSelectedConfidence = confidence => {
  return {
    type: types.FAMILY_MATCH_SET_CONFIDENCE,
    payload: confidence,
  };
};

export const checkApplicationRow = (shouldCheck, row) => {
  return {
    type: types.FAMILY_MATCH_CHECK_APPLICATION_GRID,
    payload: { shouldCheck, row },
  };
};

export const checkStudentRow = (shouldCheck, row) => {
  return {
    type: types.FAMILY_MATCH_CHECK_STUDENT_GRID,
    payload: { shouldCheck, row },
  };
};

export const checkSelectedConfidence = () => {
  return this.state.selectedConfidence;
};

export const setSaveSuccessful = value => {
  return {
    type: types.FAMILY_MATCH_SET_SUCCESS_FLAG,
    payload: value,
  };
};

export const clearError = () => {
  return {
    type: types.FAMILY_MATCH_CLEAR_ERRORS,
  };
};

export const setNoStudent = value => {
  return {
    type: types.FAMILY_MATCH_SET_NO_STUDENT_FLAG,
    payload: value,
  };
};

export const clearSelectedStudents = () => {
  return {
    type: types.FAMILY_MATCH_CLEAR_SELECTED_STUDENTS,
  };
};

export const toggleHistory = value => {
  return {
    type: types.FAMILY_MATCH_TOGGLE_HISTORY,
    payload: value,
  };
};

export const addAppToHistory = applicationObject => {
  return {
    type: types.FAMILY_MATCH_ADD_TO_HISTORY,
    payload: applicationObject,
  };
};



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/state/actions.js